const fertilizersList = [
    {
        "id": "ilac1",
        "name": "Basic 18.18.5 32S",
        "image": "https://productimages.hepsiburada.net/s/187/300-443/110000152583930.jpg",
        "info": "40 Kg"
    },
    {
        "id": "ilac2",
        "name": "Stweet",
        "image": "",
        "info": "500 CC"
    },
    {
        "id": "ilac3",
        "name": "AKC Org. Plus Toz",
        "image": "",
        "info": "25K"
    },
    {
        "id": "ilac4",
        "name": "Microway",
        "image": "https://growway.com.tr/wp-content/uploads/2021/06/Microway-Growway-2022.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac5",
        "name": "Elferplant",
        "image": "https://www.gentatarim.com/urun-gorselleri/10.9.2019-Elfer-Root.jpg",
        "info": "50 Gr"
    },
    {
        "id": "ilac6",
        "name": "Sequestrene",
        "image": "https://productimages.hepsiburada.net/s/24/1500/10075643150386.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac7",
        "name": "Poly Aquaje",
        "image": "http://gnctarim.net/image/cache/catalog/urunler/aquaje-800x800.jpg",
        "info": "500 Gr"
    },
    {
        "id": "ilac8",
        "name": "Stable N-36",
        "image": "https://dogatech.com.tr/wp-content/uploads/2023/01/dogatech-stable-n-36.jpg",
        "info": "25 Kg"
    },
    {
        "id": "ilac9",
        "name": "Humirota",
        "image": "https://sectortarim.com.tr/images/sector/urunler/sector/tr/humirot.jpg",
        "info": "20 Kg"
    },
    {
        "id": "ilac10",
        "name": "Sequplant",
        "image": "",
        "info": "1 Kg"
    },
    {
        "id": "ilac11",
        "name": "Elferfruit Plus",
        "image": "https://images.hepsiburada.net/assets/ProductDescription/202012/cdf1cfb9-d890-4195-91ae-cdbf8f9aad90.jpg",
        "info": "500 Gr"
    },
    {
        "id": "ilac12",
        "name": "Lotus-KTS",
        "image": "https://tarimdayiz.com/public/uploads/products/photos/0pEnEcDVJgp5U7PIxPbljtF47XeEmWtEXpnoqVIK.png",
        "info": "20 Lt"
    },
    {
        "id": "ilac13",
        "name": "Nivamic Ferrix",
        "image": "",
        "info": "1 Kg"
    },
    {
        "id": "ilac14",
        "name": "Euro-Fer",
        "image": "https://www.eurosolids.com/wp-content/uploads/sites/6/2017/08/ES20box20EN20Euro20Fer20Duathlon@10x.png",
        "info": "1 Kg"
    },
    {
        "id": "ilac15",
        "name": "Proximo Katı",
        "image": "https://cdn.dsmcdn.com/ty294/product/media/images/20220114/10/26477402/214277350/1/1_org_zoom.jpg",
        "info": "400 Gr"
    },
    {
        "id": "ilac16",
        "name": "Feretti6-Fe",
        "image": "https://korumatarim.com/wp-content/uploads/2022/01/Ferretti-6-Fe.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac17",
        "name": "Maxi-Crop",
        "image": "http://www.toptantarim.com/images/urunler/maxi-crop-400gr-resim-493.jpg",
        "info": "400 Gr"
    },
    {
        "id": "ilac18",
        "name": "Biofix Bs",
        "image": "https://scontent.fsaw1-15.fna.fbcdn.net/v/t1.6435-9/158137657_3803432183072879_5935022997546133034_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=IIvzctsZyacAX_XXMyh&_nc_ht=scontent.fsaw1-15.fna&oh=00_AfDjJuVzjjEuZWnFhIxmYG2mULcHQkrkk0i8-FyHclXz4w&oe=6433244A",
        "info": "1 Lt"
    },
    {
        "id": "ilac19",
        "name": "Eurolex Mix",
        "image": "https://www.mentatarim.com/yukleme/urunler/resim/t/eurolex-mix.jpg",
        "info": "20 Lt"
    },
    {
        "id": "ilac20",
        "name": "Greenmax",
        "image": "https://productimages.hepsiburada.net/s/75/375/110000016898861.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac21",
        "name": "Humiment 15",
        "image": "https://www.mentatarim.com/yukleme/urunler/resim/t/humiment.jpg",
        "info": "20 Lt"
    },
    {
        "id": "ilac22",
        "name": "Elfer Fruit",
        "image": "https://n11scdn.akamaized.net/a1/450/ev-yasam/bitki-besini-ve-vitamin/genta-ciceklendirici-hormon-elfer-fruit-50-g__1326418095546402.jpg",
        "info": "600 Gr"
    },
    {
        "id": "ilac23",
        "name": "Stable N-21",
        "image": "https://dogatech.com.tr/wp-content/uploads/2023/01/dogatech-stable-n-21.jpg",
        "info": "25 Kg"
    },
    {
        "id": "ilac24",
        "name": "PH5",
        "image": "",
        "info": "1 Lt"
    },
    {
        "id": "ilac25",
        "name": "Plantafol 10.54.10",
        "image": "https://n11scdn.akamaized.net/a1/640/ev-yasam/gubre/plantafol-105410-1kg-ithal-gubre__0223606504578036.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac26",
        "name": "Magbozin-P",
        "image": "https://www.mentatarim.com/yukleme/urunler/resim/t/magbozin-p.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac27",
        "name": "Multicomb",
        "image":"",
        "info": "1 Kg"
    },
    {
        "id": "ilac28",
        "name": "Kelafer 500 WDG",
        "image": "https://www.agriges.com/public/upload/kelafer_500_wdg.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac29",
        "name": "Caracas",
        "image": "https://github.com/RealCodeMate/SoydanTarim/blob/main/soydantarim/src/assets/galleryImg/caracas.jpeg?raw=true",
        "info": "1 Lt"
    },
    {
        "id": "ilac30",
        "name": "Alles",
        "image": "https://github.com/RealCodeMate/SoydanTarim/blob/main/soydantarim/src/assets/galleryImg/alles.jpeg?raw=true",
        "info": "1 Kg"
    },
    {
        "id": "ilac31",
        "name": "Miramax Combi Plus",
        "image": "https://www.mentatarim.com/yukleme/urunler/resim/t/miramax-combi-plus.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac32",
        "name": "Usadro Samp.",
        "image": "https://n11scdn.akamaized.net/a1/602_857/05/42/28/88/IMG-4092341931302088559.png",
        "info": "20 Lt"
    },
    {
        "id": "ilac33",
        "name": "Neva-K",
        "image": "https://www.mentatarim.com/yukleme/urunler/resim/t/neva---k.jpg",
        "info": "20 Lt"
    },
    {
        "id": "ilac34",
        "name": "Flora-X",
        "image": "https://www.izagri.com.tr/wp-content/uploads/2020/10/flora-x.jpg",
        "info": "600 CC"
    },
    {
        "id": "ilac35",
        "name": "Auxigro",
        "image": "https://cdn-merchant.ganipara.com/assets/12069/product/950692/grande_2-org-zoom-1667655970.jpg",
        "info": "200 Gr"
    },
    {
        "id": "ilac36",
        "name": "Synthron Fe",
        "image": "https://cdn.agrobayi.com/Media/Ilan/2415/sytron.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac37",
        "name": "Proway 312",
        "image": "https://productimages.hepsiburada.net/s/25/550/10136295669810.jpg/format:webp",
        "info": "1 Kg"
    },
    {
        "id": "ilac38",
        "name": "MC Set ",
        "image": "https://www.valagro.com/media/products/product/image/generated_MC_SET_1L.jpg.600x600_q85_crop.jpg",
        "info": "1 Lt"
    },
    {
        "id": "ilac39",
        "name": "Magnezyum Sülfat",
        "image": "https://cdn-merchant.ganipara.com/assets/12069/product/941655/grande_adomag-1653986996.jpg",
        "info": "25 Kg"
    },
    {
        "id": "ilac40",
        "name": "Octavius Znp",
        "image": "https://www.mentatarim.com/yukleme/urunler/resim/t/octavius-znp.jpg",
        "info": "20 Lt"
    },
    {
        "id": "ilac41",
        "name": "Green Plus 10.10.40",
        "image": "",
        "info": "25 Kg"
    },
    {
        "id": "ilac42",
        "name": "Vonda",
        "image": "https://www.mentatarim.com/yukleme/urunler/resim/t/vonda.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac43",
        "name": "Green Plus 16.8.24",
        "image": "",
        "info": "25 Kg"
    },
    {
        "id": "ilac44",
        "name": "Mr.Farmer 18.18.18",
        "image": "https://mrfarmer.com.tr/wp-content/uploads/2021/09/mr-farmer-18-18-18te-1024x683.jpg",
        "info": "25 Kg"
    },
    {
        "id": "ilac45",
        "name": "Flower BZNP",
        "image": "https://www.tarim11.com/img/besleme/20220331101436464.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac46",
        "name": "İdha CU",
        "image": "https://www.timplantcare.com.tr/upload/products/idha_cu_10.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac47",
        "name": "Biogip",
        "image": "https://productimages.hepsiburada.net/s/336/550/110000342309563.jpg/format:webp",
        "info": "1 Lt"
    },
    {
        "id": "ilac48",
        "name": "Maxifruit",
        "image": "",
        "info": "1 Lt"
    },
    {
        "id": "ilac49",
        "name": "Flora-X",
        "image": "https://productimages.hepsiburada.net/s/4/550/9629277552690.jpg/format:webp",
        "info": "1 Lt"
    },
    {
        "id": "ilac50",
        "name": "Colostrum",
        "image": "https://www.dogatarim.com/Resim/Upload/colostrum1lt.png",
        "info": "1 Lt"
    },
    {
        "id": "ilac51",
        "name": "Decco Sound Micro",
        "image": "https://cdn.dsmcdn.com/ty342/product/media/images/20220228/19/60157508/399774978/1/1_org_zoom.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac52",
        "name": "Mustang D",
        "image": "http://admin.pinartarimmarket.com/Images/Urun/131631693424828465.jpg",
        "info": "1 Kg"
    },
    {
        "id": "ilac53",
        "name": "Sulfacit",
        "image": "https://scontent.fteq3-1.fna.fbcdn.net/v/t1.6435-9/80031576_3251937094822444_3865300343961157632_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=973b4a&_nc_ohc=qVyMzyoOxjsAX9Jkr7k&_nc_ht=scontent.fteq3-1.fna&oh=00_AfC_sCLTy_vwyk6RabcyxM6XRjJqiqbZ7pbQkRTLz9_t5A&oe=64333A78",
        "info": "10 Lt"
    },
    {
        "id": "ilac53-1",
        "name": "Hektafermin",
        "image": "https://hektas.com.tr/wp-content/uploads/2021/06/Hektafermin-300x300_EN.jpg",
        "info": "1 Lt"
    },
    {
        "id": "ilac54",
        "name": "Feron",
        "image": "https://mentatarim.com/yukleme/urunler/resim/t/feron-6-fe.jpg",
        "info": "5 Kg"
    },
    {
        "id": "ilac55",
        "name": "Polycal",
        "image": "https://productimages.hepsiburada.net/s/148/550/110000102969917.jpg/format:webp",
        "info": "1 Kg"
    },
    {
        "id": "ilac56",
        "name": "Adress",
        "image": "",
        "info": "2 Kg"
    },
    {
        "id": "ilac57",
        "name": "Megafol",
        "image": "https://img.b2b.trade/0b12a52c-50ab-4f76-8629-65b8eb4ed3ad/-/smart_resize/500x500/-/quality/lightest/-/format/webp/",
        "info": "1 Lt"
    },
    {
        "id": "ilac58",
        "name": "Glory N30",
        "image": "",
        "info": "20 Lt"
    },
    {
        "id": "ilac59",
        "name": "Decco Calcium",
        "image": "https://www.deccoitalia.it/wp-content/uploads/2018/03/calcium-1024x1024.jpg",
        "info": "1 Lt"
    },
    {
        "id": "ilac60",
        "name": "Renat",
        "image": "https://growway.com.tr/wp-content/uploads/2021/06/Renat40-800X1200PX.jpg",
        "info": "20 Lt"
    },
    {
        "id": "ilac61",
        "name": "Store",
        "image": "https://github.com/RealCodeMate/SoydanTarim/blob/main/soydantarim/src/assets/galleryImg/store.jpeg?raw=true",
        "info": "10 Kg"
    },
    {
        "id": "ilac62",
        "name": "Everfeed",
        "image": "https://cdn.dsmcdn.com/ty101/product/media/images/20210406/15/78238378/161301152/1/1_org_zoom.jpg",
        "info": "5 Kg"
    },
    {
        "id": "ilac63",
        "name": "Rame",
        "image": "https://productimages.hepsiburada.net/s/48/1500/10957342277682.jpg",
        "info": "1 Lt"
    },
    {
        "id": "ilac64",
        "name": "Quex",
        "image": "",
        "info": "1 Lt"
    },
    {
        "id": "ilac65",
        "name": "Calbit C",
        "image": "https://cdn.dsmcdn.com/ty351/product/media/images/20220308/10/64630870/407710890/1/1_org_zoom.jpg",
        "info": "1 Lt"
    },
    {
        "id": "ilac66",
        "name": "Euro-Fer",
        "image": "http://www.cagintarim.com/images/kimyevi/eurofer.png",
        "info": "5 Kg"
    },
    {
        "id": "ilac67",
        "name": "Nutrisolnpk",
        "image": "https://cdn.dsmcdn.com/ty360/product/media/images/20220314/14/69731352/415427856/1/1_org_zoom.jpg",
        "info": "1 Kg"
    },
]

export default fertilizersList; 